import { Avatar, Button, Skeleton, Typography, Grid } from '@mui/material'
import React from 'react'
import { styled } from '@mui/material/styles'
import { selectArtistResults, selectSearchTerm, selectTrackResults } from '../../../actions/discoverSlice'
import { useDispatch, useSelector } from 'react-redux'
import { Stack } from '@mui/system'
import { Link } from 'react-router-dom'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import placeholder from '../../../assets/placeholder_artist.jpg'
import { useLikeByTypeMutation } from '../../../api/userApiSlice'
import { setShowSubscribe } from '../../../actions/mainSlice'
import { useGetUserQuery } from '../../../api/userApiSlice'
import TrackRow from '../../track/TrackRow'
import { AppDispatch } from '../../../core/store'

const LeftItem = styled(Grid)(({ theme }) => ({
    maxHeight: '50%',
    padding: "8px",
    backgroundColor: '#ffffff00',
    borderRadius: '16px',
    overflow: 'hidden'
}))

const SearchCardResults = ({closeModale}: any) => {
  const dispatch = useDispatch<AppDispatch>()
  const [likeContent] = useLikeByTypeMutation()

  const searchTerm = useSelector(selectSearchTerm)
  const findedArtists = useSelector(selectArtistResults)
  const findedTracks = useSelector(selectTrackResults)

  const {
    data: user,
    refetch
  } = useGetUserQuery({})

  const likeArtistById = async (ID: string) => {
    try {
      const like = await likeContent({target_id: ID, type: 'artist'}).unwrap()
      refetch()
      if(like) {
          console.log('TODO: Use like')
      }
    } catch (error) {
      dispatch(setShowSubscribe({showSubscribe: true}))
    }
  }
      
  return searchTerm ? (
    <Grid container spacing={1} sx={{mb: 2, maxHeight: '60vh', overflow: 'hidden', overflowY: 'scroll'}}>
      { 
        findedArtists && findedArtists.length >= 1
        ? <LeftItem size={12}>
          <Typography variant='subtitle1' color='secondary' sx={{textAlign: 'center'}}>{ findedArtists ? findedArtists.length > 1 ? `${findedArtists.length} Artistes` : `${findedArtists.length} Artiste` : '--'}</Typography>
           <Stack>
          {
            findedArtists && findedArtists.length >= 1
            ?
              findedArtists.map( (artist: Artist) => {
                return (
                //  
                  <Stack direction={'row'} key={artist._id} sx={{p: 1}} onClick={closeModale}>
                    <Link key={artist._id} to={`/artist/${artist._id}`}><Avatar src={artist.avatar_url ? artist.avatar_url.replace("cw.png","cc.png") : placeholder} sx={{width: '6vh', height: '6vh', mr: 1}}/></Link>
                    <Grid size={8} container alignContent={'center'}>
                        <Grid size={12} sx={{'& a': {  textDecorationColor: '#7C7CCF'}}}>
                        <Link key={artist._id} to={`/artist/${artist._id}`} className='full-width' ><Typography variant='h6' color={'secondary.main'} sx={{fontSize: '1em', textAlign: 'left'}}>{artist.artist_name}</Typography></Link>
                        </Grid>
                        <Grid size={12}>
                          <Typography color={'secondary.main'} sx={{fontSize: '0.8em', fontStyle: 'italic', textAlign: 'left'}}>{artist.genre_names.length > 0 ? artist.genre_names.join(', ') : '--'}</Typography>
                        </Grid>
                    </Grid>
                    <Grid size={3} alignContent={'center'}>
                      <Stack direction={'row'} justifyContent={'end'}>
                          <Button onClick={() => likeArtistById(artist._id)} color="secondary" sx={{minWidth: '32px'}}>{ user && user.likes && user.likes.filter((like: any) => like.target_id === artist._id).length > 0 ?  <FavoriteIcon sx={{fontSize: 20}} /> : <FavoriteBorderIcon sx={{fontSize: 20}} /> }</Button>
                          {/* <Button color="primary" sx={{minWidth: '32px'}}><ShareIcon sx={{fontSize: 20}} color='primary.main'/></Button> */}
                      </Stack>
                    </Grid>
                  </Stack>
              )})
            :
            <Grid container spacing={2} alignContent={'center'} sx={{height: '10vh', p: 2}}>
              <Grid size={3}>
                <Skeleton variant='circular' sx={{width: '5vh', height: '5vh'}}/>
              </Grid>
              <Grid size={6} alignContent={'center'}>
                <Skeleton />
                <Skeleton />
              </Grid>
              <Grid size={3} alignItems={'end'} alignContent={'end'} alignSelf={'center'}>
                <Skeleton variant='rounded' sx={{width: '3vh', height: '3vh'}} />
              </Grid>
            </Grid>
          }
          </Stack>
        </LeftItem>
        : '' } 
        {
          findedTracks && findedTracks.length >= 1
          ? <LeftItem size={12}>
            <Typography variant='subtitle1' color='secondary' sx={{textAlign: 'center'}}>{ findedTracks ? findedTracks.length > 1 ? `${findedTracks.length} Tracks` : `${findedTracks.length} Track` : '--'}</Typography>
            <Stack>

            {
              findedTracks && findedTracks.length > 0
              ?
                findedTracks.map( (track: Track, i: number) => <TrackRow onClick={closeModale} color={'#7C7CCF'} index={i} track={track} maxProducers={5} fromAlbum={false} />)
              :
                <Grid container spacing={2} alignContent={'center'} sx={{height: '10vh', p: 2}}>
                  <Grid size={3}>
                    <Skeleton variant='circular' sx={{width: '5vh', height: '5vh'}}/>
                  </Grid>
                  <Grid size={6} alignContent={'center'}>
                    <Skeleton />
                    <Skeleton />
                  </Grid>
                  <Grid size={3} alignItems={'end'} alignContent={'end'} alignSelf={'center'}>
                    <Skeleton variant='rounded' sx={{width: '3vh', height: '3vh'}} />
                  </Grid>
                </Grid>
            }
            </Stack>
          </LeftItem>
        : '' }
      </Grid>
    ) : null
}

export default SearchCardResults